import { DestroyRef, inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { LoaderService } from '../loader.service';
import { Selectable } from '../../models/types/selectable.type';


@Injectable({
  providedIn: 'root',
})
export abstract class IFilterListService<T> {

  readonly graphQlService = inject(GraphQLService);
  readonly appService = inject(AppService);
  readonly destroyRef = inject(DestroyRef);
  readonly loaderService = inject(LoaderService);

  isSearching: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  datasource: BehaviorSubject<Array<Selectable<T>>> = new BehaviorSubject<Array<Selectable<T>>>([]);

  get datasourceLabel(): string {
    return this.datasource.getValue().join(', ').slice(0, 20);
  }

  abstract search(searchText: string, variables?: any, isFirst?: boolean): void;

  toggleSelection(item: Selectable<T>): void {
    const actualValue = this.datasource.getValue();
    const updated = actualValue.map(el =>
      el.displayId === item.displayId
        ? { ...el, selected: false }
        : el
    );
    this.datasource.next(updated);
  }

  toggleRemoveSelection(item: Selectable<T>): void {
    const actualValue = this.datasource.getValue();
    const updated = actualValue.map(el =>
      el.displayId === item.displayId
        ? { ...el, selected: false }
        : el
    );
    this.datasource.next(updated);
  }

  restore(datasource: Array<Selectable<T>>): void {
    const actualValue = this.datasource.getValue();
    const updated = actualValue.map(el =>
      datasource.some(ds => el.displayId === ds.displayId)
        ? { ...el, selected: true }
        : { ...el, selected: false }
    );
    this.datasource.next(updated);
  }

  clearSelection(): void {
    const actualValue = this.datasource.getValue();
    const updated = actualValue.map(el => ({ ...el, selected: false }));
    this.datasource.next(updated);
  };
}
